import { combineReducers } from 'redux'
import records from './records'
import uiFlags from './uiFlags'
import stagedRecord from './stagedRecord'
import position from './position'

export default combineReducers({
  records,
  uiFlags,
  stagedRecord,
  position,
})
